// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".group[data-v-7dc428b4]{display:flex;flex-direction:row}.group__item[data-v-7dc428b4]{margin:5px 25px 5px 0;min-width:75px}.group--vertical[data-v-7dc428b4]{flex-direction:column}.group--invalid .group__item[data-v-7dc428b4]{color:var(--c-error)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
